<template>
  <div>
    <input type="hidden" v-model="formattedDate" :name="fieldName">
    <datepicker
      v-model="date"
      :openDate="openDate"
      :name="fieldName"
      :inline="true"
      :disabled="disabled"
      :highlighted="highlighted"
      format="yyyy-MM-dd">
    </datepicker>
  </div>
</template>


<script>
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'

  export default {
    props: ['initDate', 'rangeStart', 'fieldName'],
    components: {
      Datepicker
    },
    data() {
      return {
        date: '',
        disabledx: {
          to: null
        },
        disabled: false,
        disabledTo: null,
        highlighted: {
          dates: [
            new Date()
          ]
        },
        openDate: new Date()
      }
    },
    mounted() {
      this.formatDisabledTo()
      this.formatOpenDate()

    },
    computed: {
      formattedDate: {
        get () {
          if (this.date) {
            return moment(this.date).format('YYYY-MM-DD')
          }
        },
        set (date) {
          this.date = date
        }
      },
    },
    methods: {
      formatDisabledTo() {
        if (this.rangeStart) {
          this.disabledTo = moment(this.rangeStart)
        }
      },
      formatOpenDate() {
        if (this.initDate) {
          this.openDate = moment(this.initDate)
          this.highlighted.dates = [this.openDate]
          this.date = this.openDate
        }
      },
      cleanUpDbDate(date) {
        return date.trim().split(' ')[0]
      }
    }
  }
</script>

